<p-table #dt [columns]="cols" [value]="listArchives | async"  
[(selection)]="selectedClients"  
  dataKey="idClient" >
    <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix" style="text-align: left">
            <button type="button" *ngIf="false" pButton icon="pi pi-file-o" iconPos="left" label="CSV" (click)="dt.exportCSV()" style="margin-right: 0.5em;" class="btn-def"></button>
            <button type="button" *ngIf="false" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL" (click)="exportExcel()" style="margin-right: 0.5em;" class="btn-def"></button>
            <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" label="PDF" (click)="exportPdf()" class="btn-def"></button>
       
            <button type="button" style="float:right;margin-left: 10px;color: white;" pButton icon="pi pi-file-pdf" iconPos="left"
            label="Notification d'entrer ZIP" (click)="printNotifications(true,true)" class="btn-def" ></button>

            <button type="button" style="float:right;margin-left: 10px;color: white;" pButton icon="pi pi-file-pdf" iconPos="left"
            label="Notification de sortie ZIP" (click)="printNotifications(false,true)" class="btn-def" ></button>


            <button type="button" style="float:right;margin-left: 10px;color: white;" pButton icon="pi pi-print" iconPos="left"
            label="Entré En masse" (click)="printNotifications(true,false)" class="btn-def" ></button>

            <button type="button" style="float:right;margin-left: 10px;color: white;" pButton icon="pi pi-print" iconPos="left"
            label="Sortie En masse" (click)="printNotifications(false,false)" class="btn-def" ></button>



            <button type="button" style="float:right;margin-left: 10px;color: white;" pButton icon="pi pi-file-pdf" iconPos="left"
             label="Notification de sortie" (click)="printNotification(false)" class="btn-def" ></button>

            <button type="button" class="btn-def" style="float:right; " pButton icon="pi pi-file-pdf" iconPos="left"
             label="Notification d'entrée" (click)="printNotification(true)"  ></button>
 
        </div>
    </ng-template>



    <ng-template pTemplate="header" let-colsVaraible>
        <tr>
            <th style="width: 3em">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th *ngFor="let col of colsVaraible"  [style.width]="col.width">
                {{col.header}}
            </th>
            <th style="width: 100px;"   >Fiche Client</th>
        
        </tr>

        <tr>
            <th style="width: 100px;" > </th>
            <th *ngFor="let col of cols"  [ngSwitch]="col.field">
             
                <p-dropdown *ngSwitchCase="'type'" [options]="types" [style]="{'width':'100%'}" (onChange)="dt.filter($event.value, col.field, 'equals')"></p-dropdown>
                <input style="width:100% ;" *ngSwitchDefault pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">

           </th>

           


           <th style="width: 100px;" > </th>
        </tr>

    </ng-template>
    <ng-template pTemplate="body" let-row let-colsVaraible="columns">
        <tr  >
           
            <td>
                <p-tableCheckbox [value]="row"></p-tableCheckbox>
            </td>
            <td *ngFor="let col of colsVaraible"  [ngSwitch]="col.field">
          <div  *ngSwitchCase="'type'">{{convertType(row[col.field])}} </div>
          <div *ngSwitchDefault>{{row[col.field]}}</div>
                
            </td>
            <td  >
              <mat-icon  [routerLink]="['/add-exhibitor',{idClient:row.idClient}]">folder_open</mat-icon> 
            </td>
        </tr>
    </ng-template>
   
  
</p-table>
<p-dialog header="Loading..." appendTo='body' [(visible)]="isLoading" [modal]="true"  [style]="{width: '200px', minWidth: '200px'}"  >
    <p-progressSpinner></p-progressSpinner>
</p-dialog>
 